import React from "react";
import { Refresh } from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";
import { CopyIcon } from "@100mslive/react-icons";
import { Flex } from "@100mslive/roomkit-react";
import { VerifedIcon } from "../../../../icons";
import { ToastManager } from "../../../Toast/ToastManager";

const SendgrindVerify = props => {
  const { onValidate, verifyData, onClose } = props;

  const CopyText = val => {
    navigator.clipboard.writeText(val);
    ToastManager.addToast({ title: "Copied!" });
  };

  return (
    <React.Fragment>
      {/* {loading ? <FullPageProgress fixed={true} /> : null} */}
      <div className="events-page-setup-steps-body">
        <div className="events-page-setup-steps-body-title mb-10">
          Email: {verifyData?.domain?.domain}
        </div>

        <div className="events-page-setup-steps-body-text">
          Go to your DNS provider and create the following DNS records. Once
          done, click "Verify Setup" below to verify your configuration. We
          additionally will check on your behalf over the next 24 hours.
        </div>

        <div className="events-page-setup-steps-body-text">
          These records will validate that you own this domain so that our email
          provider can generate the corresponding SPF and DKIM for secure and
          verified sending.
        </div>
        {Object.keys(verifyData?.domain.dns).map((item, index) => (
          <Flex className="events-sendgrid-box mt-5" key={index}>
            <table className="events-sendgrid-box-table">
              <tbody>
                <tr>
                  <th>Type:</th>
                  <td>{verifyData?.domain.dns?.[item]?.type}</td>
                  <td>
                    <Button
                      size="small"
                      variant="outlined"
                      className="events6ix-btn  events6ix-btn-secondary events6ix-btn-sm"
                      onClick={onValidate}
                    >
                      <Refresh />
                    </Button>
                    <div className="events-sendgrid-box-table-icon">
                      <IconButton size="small" disabled>
                        {verifyData?.domain.dns?.[item]?.valid ? (
                          <VerifedIcon check />
                        ) : (
                          <VerifedIcon cross />
                        )}
                      </IconButton>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th>host:</th>
                  <td>
                    <div className="events-sendgrid-box-table-txt">
                      {verifyData?.domain.dns?.[item]?.host}
                    </div>
                  </td>
                  <td>
                    <Button
                      size="small"
                      variant="outlined"
                      className="events6ix-btn  events6ix-btn-secondary events6ix-btn-sm"
                      onClick={() => {
                        CopyText(verifyData?.domain.dns?.[item]?.host);
                      }}
                    >
                      <CopyIcon />
                    </Button>
                  </td>
                </tr>
                <tr>
                  <th>Value:</th>
                  <td>
                    <div className="events-sendgrid-box-table-txt">
                      {verifyData?.domain.dns?.[item]?.data}
                    </div>
                  </td>
                  <td>
                    <Button
                      size="small"
                      variant="outlined"
                      className="events6ix-btn  events6ix-btn-secondary events6ix-btn-sm"
                      onClick={() => {
                        CopyText(verifyData?.domain.dns?.[item]?.data);
                      }}
                    >
                      <CopyIcon />
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </Flex>
        ))}
      </div>

      <div className="events-page-setup-steps-body">
        <div className="events-page-setup-steps-body-title mb-10">
          Branded Links: {verifyData?.link?.domain}
        </div>

        <div className="events-page-setup-steps-body-text">
          Branded Links are custom short links unique to your custom domain. To
          learn more about Branded Links and how they are important to you,
          visit the 6ix knowledge base.
        </div>

        <div className="events-page-setup-steps-body-text">
          Go to your DNS provider and create the following DNS records. Once
          done, click "Verify Setup" below to verify your configuration. We
          additionally will check on your behalf over the next 24 hours.
        </div>
        {Object.keys(verifyData?.link.dns).map((item, index) => (
          <Flex className="events-sendgrid-box mt-5" key={index}>
            <table className="events-sendgrid-box-table">
              <tbody>
                <tr>
                  <th>Type:</th>
                  <td>{verifyData?.link?.dns?.[item]?.type}</td>
                  <td>
                    <Button
                      size="small"
                      variant="outlined"
                      className="events6ix-btn  events6ix-btn-secondary events6ix-btn-sm"
                      onClick={onValidate}
                    >
                      <Refresh />
                    </Button>
                    <div className="events-sendgrid-box-table-icon">
                      <IconButton size="small" disabled>
                        {verifyData?.link.dns?.[item]?.valid ? (
                          <VerifedIcon check />
                        ) : (
                          <VerifedIcon cross />
                        )}
                      </IconButton>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th>host:</th>
                  <td>
                    <div className="events-sendgrid-box-table-txt">
                      {verifyData?.link.dns?.[item]?.host}
                    </div>
                  </td>
                  <td>
                    <Button
                      size="small"
                      variant="outlined"
                      className="events6ix-btn  events6ix-btn-secondary events6ix-btn-sm"
                      onClick={() => {
                        CopyText(verifyData?.link.dns?.[item]?.host);
                      }}
                    >
                      <CopyIcon />
                    </Button>
                  </td>
                </tr>
                <tr>
                  <th>Value:</th>
                  <td>
                    <div className="events-sendgrid-box-table-txt">
                      {verifyData?.link.dns?.[item]?.data}
                    </div>
                  </td>
                  <td>
                    <Button
                      size="small"
                      variant="outlined"
                      className="events6ix-btn  events6ix-btn-secondary events6ix-btn-sm"
                      onClick={() => {
                        CopyText(verifyData?.link.dns?.[item]?.data);
                      }}
                    >
                      <CopyIcon />
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </Flex>
        ))}

        <Flex justify="center" gap="20" className="text-center ">
          <Button
            size="small"
            color="primary"
            variant="outlined"
            className="events6ix-btn  events6ix-btn-primary ml-20 mt-20"
            type="button"
            onClick={onClose}
          >
            Close
          </Button>
        </Flex>
      </div>
    </React.Fragment>
  );
};

export default SendgrindVerify;
